import { render, staticRenderFns } from "./PhoneCode.vue?vue&type=template&id=9fd1ce2a&scoped=true"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"
import style0 from "./PhoneCode.vue?vue&type=style&index=0&id=9fd1ce2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd1ce2a",
  null
  
)

export default component.exports